import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import { checkSession } from './services/api';
import browserGuardService from './services/browserGuard'; // Import BrowserGuard Service
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [geoData, setGeoData] = useState(null);
  const [selectedMarket, setSelectedMarket] = useState('sportsbook');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user has an active session
    const verifySession = async () => {
      try {
        const response = await checkSession();
        if (response.authenticated) {
          setIsAuthenticated(true);
          setUser(response.user);
          setGeoData(response.geoData);

          // BrowserGuard is initialized by Dashboard on mount
        }
      } catch (error) {
        console.error('Session check failed:', error);
      } finally {
        setLoading(false);
      }
    };

    verifySession();
  }, []);

  const handleLoginSuccess = async (userData, geoDataReceived, market) => {
    setIsAuthenticated(true);
    setUser(userData);
    setGeoData(geoDataReceived);
    setSelectedMarket(market || 'sportsbook');
    
    // BrowserGuard is initialized and geo check triggered by Dashboard on mount
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    setGeoData(null);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="App">
      {!isAuthenticated ? (
        <Login onLoginSuccess={handleLoginSuccess} />
      ) : (
        <Dashboard user={user} geoData={geoData} onLogout={handleLogout} setGeoData={setGeoData} initialMarket={selectedMarket} />
      )}
    </div>
  );
}

export default App;
